function Footer(){
  return (
    <div className="footer">
      <p className="textright">Last updated 6/5/2026</p>
    </div>)
}

export default Footer
;
